import { readActiveRole } from './auth';

const ENTRY_URL_KEY = 'entryUrl';
const ENTRY_ROLE_KEY = 'entryRole';

export const getCurrentAppUrl = () => {
  return `${window.location.pathname}${window.location.search}${window.location.hash}`;
};

export const saveReloginContext = ({ url = getCurrentAppUrl(), role = readActiveRole() } = {}) => {
  if (url) {
    window.localStorage.setItem(ENTRY_URL_KEY, url);
  }

  if (role) {
    window.localStorage.setItem(ENTRY_ROLE_KEY, role);
  }
};

export const readEntryUrl = () => {
  return window.localStorage.getItem(ENTRY_URL_KEY);
};

export const readEntryRole = () => {
  return window.localStorage.getItem(ENTRY_ROLE_KEY);
};

export const clearReloginContext = () => {
  window.localStorage.removeItem(ENTRY_URL_KEY);
  window.localStorage.removeItem(ENTRY_ROLE_KEY);
};
